import { DeviceConnectivity } from '@/constants/enums';
import { GlobalToken } from 'antd';

import { ValveActivityEnum } from './ValveActivity.enum';
import { DeviceType } from '@/constants/deviceTypeEnum';

export interface ValveContainerProps {
  width: number;
  height: number;
  theme: { token: GlobalToken };
}

export const getTooltipContent = (connectivity, state, t) => {
  if (connectivity?.toLowerCase() !== DeviceConnectivity.Connected) {
    return t('Valve - Disconnected');
  }

  switch (state) {
    case null:
      return t('Valve state not found');
    case ValveActivityEnum.Close:
      return t('Closed Valve - Connected');
    default:
      return t('Open Valve - Connected');
  }
};

export const getValveRelativePosition = (valveActivity, valveCurrentPosition, deviceType) => {
  if (deviceType === DeviceType.SpillValve) return valveCurrentPosition;

  switch (valveActivity) {
    case ValveActivityEnum.Close:
      return 0;
    case ValveActivityEnum.Open:
      return 100;
    default:
      return valveCurrentPosition;
  }
};
